import React, { FC } from 'react';
import styled from 'styled-components';

import BaseCard, { IBaseCard } from '@ui/atoms/BaseCard';
import BasicText from '@ui/atoms/BasicText';
import Button from '@ui/atoms/Button';
import FlexColumn from '@ui/atoms/FlexColumn';
import FlexRow from '@ui/atoms/FlexRow';

import padded from '@ui/styled/Padded';

import { exists } from '@utils/general';

import RainbowAmpersex from '@assets/vectors/rainbow-ampersex.inline.svg';

import theme from '@theme/FolxTheme';

interface IUpcomingAppointmentsCardProps {
	name: string;
	pronouns?: string;
	serviceName: string;
	appointmentDuration: string;
	appointmentDate: string;
	appointmentCta?: string;
	handleClick: () => void;
	visitType: string;
}

const PaddedCard = padded<IBaseCard>(BaseCard);

const StyledAmpersex = styled(RainbowAmpersex)`
	height: 8rem;
	width: 8rem;

	@media ${theme.responsive.breakpoints.tablet} {
		height: 9.2rem;
		width: 9.2rem;
	}
`;

const UpcomingAppointmentsCard: FC<IUpcomingAppointmentsCardProps> = ({
	name,
	pronouns,
	serviceName,
	appointmentDuration,
	appointmentDate,
	appointmentCta,
	handleClick,
	visitType,
}) => {
	return (
		<PaddedCard shadow borderless bgColor="white" padding="sm" radius="md">
			<FlexColumn gap="smmd">
				<FlexRow gap="sm">
					<StyledAmpersex />
					<FlexColumn gap="xxs">
						<FlexRow gap="sm">
							<BasicText>{name}</BasicText>
							{exists(pronouns) && <BasicText>{pronouns}</BasicText>}
						</FlexRow>
						<BasicText variant="fineprint">{serviceName}</BasicText>
						<BasicText variant="fineprint">{appointmentDuration}</BasicText>
						<BasicText variant="fineprintBold">{appointmentDate}</BasicText>
					</FlexColumn>
				</FlexRow>
				{appointmentCta && (
					<Button radius="xxxl" label={appointmentCta} labelSize="sm" onClick={handleClick} />
				)}
			</FlexColumn>
		</PaddedCard>
	);
};

export default styled(UpcomingAppointmentsCard)``;
